<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <b-button variant="outline-primary" size="sm" @click="$router.push('/manual-grupos/tree')">
        <i class="fas fa-sitemap mr-1"></i>
        Ver Árvore
      </b-button>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'manualGrupoCrud'"
            crudName="Grupos de Manual"
            newText="Novo Grupo"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :extra="extra"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from '../../layouts/Base/BaseCrud';
import { BButton } from 'bootstrap-vue';

export default {
  components: {
    BaseCrud,
    BButton,
  },
  data() {
    return {
      table: 'manualGrupoTable',
      columns: ['nome', 'parent_id', 'status', 'actions'],
      tableData: ['nome', 'parent_id', 'status'],
      extra: [],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ['nome', 'parent_id', 'status'],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          nome: 'Nome',
          parent_id: 'Grupo Pai',
          status: 'Status',
        },
        texts: {
          filterBy: 'Filtrar',
          defaultOption: 'Selecione',
        },
        listColumns: {
          status: [
            { id: 1, text: 'Ativo' },
            { id: 0, text: 'Inativo' },
          ],
        },
        templates: {
          parent_id: (h, row) => h('span', row.parent ? row.parent.nome : '-'),
          status: (h, row) => {
            const isActive = row.status === true || row.status === 1 || row.status === 'true';
            return h('span', { class: isActive ? 'badge badge-success' : 'badge badge-secondary' }, isActive ? 'Ativo' : 'Inativo');
          },
        },
        requestFunction(data) {
          const query = this.$parent.$parent.$parent.query(data.query);
          const requestData = { params: { ...data, query: '' } };
          return this.$http
              .get(`${this.url}?with[]=parent&orderBy=nome&${query}`, requestData)
              .catch(e => this.dispatch('error', e));
        },
      },
      endPoint: 'manual-grupos/',
      dataForm: {},
    };
  },
  methods: {
    query(query) {
      const columns = {
        nome: 'nome',
        parent_id: 'parent_id',
        status: 'status',
      };

      let filters = '';
      $.each(query, (index, value) => {
        if (columns[index]) filters += `${columns[index]}=${value}&`;
      });
      return filters;
    },
  },
};
</script>
